import { App } from 'antd'
import type { MessageInstance } from 'antd/es/message/interface'
import type { ModalStaticFunctions } from 'antd/es/modal/confirm'
import type { NotificationInstance } from 'antd/es/notification/interface'

export const antdStaticApp: {
  message: MessageInstance
  notification: NotificationInstance
  modal: Omit<ModalStaticFunctions, 'warn'>
} = {} as {
  message: MessageInstance
  notification: NotificationInstance
  modal: Omit<ModalStaticFunctions, 'warn'>
}

export function AntdStaticAppProvider() {
  const staticFunction = App.useApp()
  antdStaticApp.message = staticFunction.message
  antdStaticApp.notification = staticFunction.notification
  antdStaticApp.modal = staticFunction.modal

  return null
}
